import React from "react";
import { Grid } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import ConfigRender from "./components/patterns/ConfigRender/ConfigRender";
import { QuestionTypes } from "../../../static/enums/Questions";
import { useResetAnswerFields } from "../../../helpers/hooks/useResetAnswerFields";

interface InputTableAnswerProps {
	prefix?: string;
}

export default function InputTableAnswer({ prefix }: InputTableAnswerProps) {
	const { control } = useFormContext();
	const answer_config = useWatch({
		control,
		name: `${prefix}answer_config`,
	});
	const correct_answer = useWatch({
		control,
		name: `${prefix}correct_answer`,
	});

	useResetAnswerFields({
		prefix,
		defaultAnswerConfig: [],
		defaultCorrectAnswer: [],
		defaultQuestionType: QuestionTypes.input_table,
		forceReset: !answer_config || !correct_answer,
	});

	return (
		<Grid container sx={(theme) => ({ maxWidth: "100%", padding: theme.spacing(1, 0) })}>
			{Array.isArray(answer_config) && Array.isArray(correct_answer) ? <ConfigRender prefix={prefix} /> : null}
		</Grid>
	);
}
